module.exports = __webpack_public_path__ + "static/media/photo5.7f99e205.jpg";